var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormTimesheetNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F9FAFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18898_109078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8141 6.97728H8.40749C7.89386 6.97728 7.47705 6.56047 7.47705 6.04684V4.62917C7.47705 4.11554 7.89386 3.69873 8.40749 3.69873H13.8141C14.3277 3.69873 14.7446 4.11554 14.7446 4.62917V6.04684C14.7446 6.56109 14.3277 6.97728 13.8141 6.97728Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0661 13.7512C19.4877 13.1728 18.5447 13.1728 17.9663 13.7512L17.2798 14.4415L19.3808 16.5419L20.0661 15.8566C20.6507 15.2726 20.6507 14.3358 20.0661 13.7512Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6155 15.1094L12.9503 18.7683C12.8748 18.85 12.8245 18.9506 12.8057 19.0575L12.5291 20.6857C12.4662 21.0441 12.7805 21.3521 13.1389 21.2956L14.7671 21.0189C14.874 21.0001 14.9746 20.9498 15.0501 20.8743L18.7152 17.2092L16.6155 15.1094Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47 5.33936H15.6873V6.04662C15.6873 7.07953 14.8468 7.92007 13.8139 7.92007H8.40725C7.3737 7.92007 6.53379 7.07953 6.53379 6.04662V5.33936H5.73852C4.50002 5.33936 3.49414 6.34524 3.49414 7.58373V19.0571C3.49414 20.2956 4.50002 21.3015 5.73852 21.3015H11.6839C11.5884 21.0556 11.5525 20.7891 11.599 20.5231L11.875 18.8993C11.9241 18.6113 12.0561 18.3454 12.2547 18.1285L16.2563 14.1327L17.2967 13.0865C17.6834 12.6993 18.1794 12.4698 18.7131 12.4038V7.59002C18.7144 6.33895 17.7148 5.33936 16.47 5.33936ZM10.1317 14.6645H7.40388C7.09143 14.6645 6.83807 14.4112 6.83807 14.0987C6.83807 13.7863 7.09143 13.5329 7.40388 13.5329H10.1317C10.4442 13.5329 10.6975 13.7863 10.6975 14.0987C10.6975 14.4112 10.4442 14.6645 10.1317 14.6645ZM13.4712 11.4532H7.40451C7.09206 11.4532 6.8387 11.1999 6.8387 10.8874C6.8387 10.575 7.09206 10.3216 7.40451 10.3216H13.4712C13.7837 10.3216 14.037 10.575 14.037 10.8874C14.037 11.1999 13.7837 11.4532 13.4712 11.4532Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18898_109078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormTimesheetNotes);
export default __webpack_public_path__ + "static/media/formTimesheetNotes.283803c088c5de37cba3446c083acc83.svg";
export { ForwardRef as ReactComponent };